import { OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, request } from "services/request";

const resource = "api/organizationEmployees";

const getList = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter } });
    return request(`${resource}/getList${query}`, { method: "GET" });
};

const getInvitationsList = (params: {}) => {
    const query = queryCollection(params);
    return request(`${resource}/getInvitationList${query}`, { method: "GET" });
};

const ban = (params: {}) => alertRequest(`${resource}/ban`, body(params));

const unban = (params: {}) => alertRequest(`${resource}/unban`, body(params));

const invite = (params: {}) => alertRequest(`${resource}/invite`, body(params));

const removeInvite = (params: {}) => alertRequest(`${resource}/removeInvite`, body(params));

export { getList, getInvitationsList, ban, unban, invite, removeInvite };
